<template>
  <div data-test-id="social-icons">
    <div
      v-for="social in siteSocials"
      :key="social"
    >
      <q-icon
        v-if="socialIconsColor == 'black' || socialIconsColor == 'white' || socialIconsColor == 'grey'"
        class="col-auto"
        :color="socialIconsColor"
        :size="iconSize"
        :name="iconName(social)"
        :aria-label="$t('image.iconFor', { social: social })"
        @click="handleSocialClick(social)"
      />
      <img
        v-else
        class="col-auto"
        style="cursor: pointer;"
        :style="{ 'width': iconSize }"
        :src="'/icons/' +social + '-128.png'"
        :alt="$t('image.iconFor', { social: social })"
        @click="handleSocialClick(social)"
      >
    </div>
  </div>
</template>

<script>
const socials = ['facebook', 'instagram', 'twitter', 'snapchat', 'youtube', 'tiktok']
export default {
  name: 'SocialIcons',
  props: {
    socialIconsColor: {
      type: String,
      required: false,
      default: 'grey'
    },
    iconSize: {
      type: String,
      required: false,
      default: '36px'
    }
  },
  computed: {
    siteSocials () {
      return _.filter(socials, social => this.currentSite[social])
    }

  },
  created () {
    _.extend(this, {
      socials
    })
  },
  context: ['currentUser'],
  configuration: ['currentSite'],
  methods: {
    iconName (social) {
      if (social === 'facebook') {
        return 'fab fa-facebook-f'
      } else if (social === 'twitter') {
        return 'fab fa-x-twitter'
      } else {
        return `fab fa-${social}`
      }
    },
    handleSocialClick (name) {
      this.$trackEvent(this.$customerEvents.CLICKED_SOCIAL_ICON, { name })

      if (_.includes(socials, name)) {
        if (name === 'tiktok') {
          window.open(`https://${name}.com/@` + this.currentSite[name], '_blank').focus()
        }
        window.open(`https://${name}.com/` + this.currentSite[name], '_blank').focus()
      }
    }
  }
}
</script>
